import AssignedLabels from './AssignedLabels';
import EditableText from './editable-text';
import CheckboxWithDetails from './CheckboxWithDetails';
import Chip from './Chip';
import InfoBanner from './InfoBanner';
import Label from './Label';
import Modal from './Modal';
import NavigateAutomatically from './NavigateAutomatically';
import SimpleDropdown from './SimpleDropdown';
import StageSelectorDropdown from './StageSelectorDropdown';
import AnimatePresence from './animation/AnimatePresence';
import WorkspaceOpsPage from './app-level/workspace-ops';
import Avatar from './avatar';
import { CopyItem } from './copy-item';
import { ImageUploadDialog } from './image-upload/image-upload-dialog';
import InfiniteScrollWrapper from './infinite-scroll-wrapper';
import { InformationBox } from './information';
import { InlineSelect } from './inline-select';
import InvisibleScroller from './invisible-scroller';
import { MessageComposerPanel } from './message-composer-panel';
import { MultiSelectDropdown } from './multi-select-dropdown';
import { SelectDropdown } from './select-dropdown';
import { ShortcutTooltip } from './shortcut-tooltip/shortcut-tooltip';
import SimpleSearchInput from './simple-search-input';
import SimpleSelect from './simple-select';
import { StageDistributionProgressBar } from './stage-distribution-progress-bar';
import { LinkedInRateLimitNudge, RateLimitWarningNudge } from './subscription-nudges';
import { CopyText } from './copy';
import { toast } from './toast';
import { Tooltip } from './tooltip';
import { WorkspaceSelector } from './workspace-selector';
import { TabSwitcher } from './tab-switcher';
import type { TabItem } from './tab-switcher';
import { LoggedInUserMenu } from './logged-in-user-menu';

// Charts (recharts) and FieldEditSection (tiptap) are intentionally not re-exported
// here — importing them via this barrel pulled both bundles into every consumer.

export {
	SimpleSelect,
	Avatar,
	EditableText,
	InfiniteScrollWrapper,
	SimpleSearchInput,
	AssignedLabels,
	CheckboxWithDetails,
	Chip,
	CopyItem,
	InfoBanner,
	MessageComposerPanel,
	Modal,
	SimpleDropdown,
	MultiSelectDropdown,
	SelectDropdown,
	StageSelectorDropdown,
	StageDistributionProgressBar,
	Tooltip,
	CopyText,
	ImageUploadDialog,
	ShortcutTooltip,
	toast,
	InvisibleScroller,
	WorkspaceSelector,
	InformationBox,
	RateLimitWarningNudge,
	LinkedInRateLimitNudge,
	NavigateAutomatically,
	WorkspaceOpsPage,
	Label,
	AnimatePresence,
	InlineSelect,
	TabSwitcher,
	LoggedInUserMenu,
};

export type { TabItem };

export { AdminOnly, AdminOnlyPlaceholder } from './admin-only';
export { ProtectedFieldBadge } from './protected-field-badge';
export { ProtectedFieldLockIcon } from './protected-field-lock-icon';
